import BadgeStatus from '@/shared/Badges/BadgeStatus'
import css from './skeletonFavouriteEquipmentLinkItem.module.css'
import cn from '@/utils/cn'
import Skeleton from '@/shared/Loaders/Skeleton'

const SkeletonFavouriteEquipmentLinkList = ({ skeletonNumber = 10 }) => {
  const renderSkeleton = (index: number) => {
    return (
      <div className={cn('inline-flex-gap gap12 center', css.wrapper)} key={index}>
        <BadgeStatus type="loaderGray" />
        <Skeleton style={{ borderRadius: '4px' }} height="16px" width={`${index % 2 === 0 ? 90 : 75}%`} />
      </div>
    )
  }

  return <div className="width100">{Array.from({ length: skeletonNumber }).map((_, i) => renderSkeleton(i))}</div>
}

export default SkeletonFavouriteEquipmentLinkList
